<template>
  <div class="flex-grow pr-2">
    <div class="rounded-2xl p-2 pl-3 pr-3 text-left relative inline-block float-right bg-sky-100" :style="customWidthStyle">
      <p class="whitespace-pre-line break-words max-w-screen-sm relative">
        <span class="block mb-2">
          {{ $t('conversation.agentReopenedThis', {agent: agent.attributes.name}) }}
        </span>
        <span class="mr-2 clear-both max-w-md block" v-linkify:options="{target: '_blank'}">{{message.text}}</span>
        <span class="text-xs text-gray-600 block text-right">
          <span v-if="hideStatus">
            {{ $t('conversation.justNow') }}
          </span>
          <span v-else>
            <Datetime v-bind:date="message.created_at" fromNow="true" />
          </span>
        </span>
      </p>
    </div>
  </div>
  <div class="flex-initial">
    <div class="relative h-14">
      <ChannelLabel v-if="channel" :channel="channel" asTooltip="true" :reopened="true" />
      <MessageAgent v-bind:agentId="message.agent_id" />
    </div>
  </div>
</template>


<script>
import Datetime from '../../building_blocks/DateTime.vue'
import ChannelLabel from '../parts/ChannelLabel.vue'
import MessageAgent from '../parts/MessageAgent.vue'
import { useAgentStore } from "@/stores/agents";

export default {
  name: 'ReopenMessage',
  props: ['message', 'channel', 'customWidthStyle', 'hideStatus'],
  setup() {
    let agentStore = useAgentStore();
    return { agentStore };
  },
  components: {
    Datetime,
    ChannelLabel,
    MessageAgent,
  },
  computed: {
    agent() {
      return this.agentStore.getById(this.message.agent_id);
    },
  },
}
</script>
